module.exports = __webpack_public_path__ + "static/media/pen-alt.d50af919.svg";